import { Checkbox } from "@mui/material";
import React, { useState, useEffect } from "react";
// import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { BACKEND_URI } from "../config";

function CartPage({
  user,
  cartItems,
  setCartItems,
  useFunds,
  setuseFunds,
  setorderType,
  setIsPickup,
  isPickup,
}) {
  const navigate = useNavigate();

  const today = new Date();
  const month = today.getMonth(); // 0-based indexing: Jan = 0, Feb = 1, ..., Dec = 11
  const date = today.getDate(); // Day of the month

  // Calculate the total amount
  const totalAmount =
    cartItems.reduce(
      (acc, item) => acc + parseFloat(item.price.slice(1)) * item.quantity,
      0
    ) * 1.0825; // Apply tax only once after summing

  const [discountRules, setDiscountRules] = useState([]);
  const [FundsinAcct, setFundsinAcct] = useState(0);
  const [paymentType, setPaymentType] = useState("Debit/Credit");

  useEffect(() => {
    const fetchDiscounts = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(`${BACKEND_URI}/api/discounts`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await response.json();
        setDiscountRules(data);
      } catch (error) {
        console.error("Error fetching discounts:", error);
      }
    };

    const fetchFundsinAcct = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(`${BACKEND_URI}/api/fundsinacct`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await response.json();
        setFundsinAcct(data);
      } catch (error) {
        console.error("Error fetching user funds:", error);
      }
    };

    fetchDiscounts();
    fetchFundsinAcct();
  }, []);

  // Handle clear cart
  const handleClearCart = () => {
    if (window.confirm("Are you sure you want to clear the cart?")) {
      setCartItems([]); // Clear the cart state locally

      const updateCartFunc = async () => {
        try {
          const token = localStorage.getItem("token");

          // Make the API call to update the cart in the database
          const response = await fetch(`${BACKEND_URI}/api/update-cart`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ cartItems: [] }), // Wrap in `cartItems` key
          });

          if (!response.ok) {
            throw new Error("Failed to update the cart");
          }
        } catch (err) {
          console.error("Error clearing cart:", err.message);
          toast.error("Failed to update cart. Please try again.");
        }
      };

      updateCartFunc(); // Call the async function
    }
  };

  // Handle remove x amount of y items
  const handleRemoveItems = (item) => {
    setCartItems((prevCartItems) => {
      // Update cart items locally
      const updatedCart = prevCartItems
        .map((cartItem) =>
          cartItem._id === item._id
            ? {
                ...cartItem,
                quantity: cartItem.quantity - 1,
              }
            : cartItem
        )
        .filter((cartItem) => cartItem.quantity > 0); // Remove items with 0 quantity

      // Update cart in the database
      updateCartInDatabase(updatedCart);

      return updatedCart;
    });
  };

  // Handle remove x amount of y items
  const handleAddItems = (item) => {
    setCartItems((prevCartItems) => {
      // Update cart items locally
      const updatedCart = prevCartItems
        .map((cartItem) =>
          cartItem._id === item._id
            ? {
                ...cartItem,
                quantity: cartItem.quantity + 1,
              }
            : cartItem
        )
        .filter((cartItem) => cartItem.quantity > 0); // Remove items with 0 quantity

      // Update cart in the database
      updateCartInDatabase(updatedCart);

      return updatedCart;
    });
  };

  // Function to update the cart in the database
  const updateCartInDatabase = async (updatedCart) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${BACKEND_URI}/api/update-cart`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ cartItems: updatedCart }), // Send updated cart to server
      });

      if (!response.ok) {
        throw new Error("Failed to update cart in database");
      }
    } catch (error) {
      console.error("Error updating cart in database:", error.message);
      toast.error("Failed to update cart in database. Please try again.");
    }
  };

  const handleToggle = (event, newStatus) => {
    if (newStatus !== null) {
      setPaymentType(newStatus);
    }
  };

  const handlePickupChange = (e) => {
    setIsPickup(e.target.checked);
  };

  const handleCheckout = () => {
    setorderType("Complete Purchase");
    navigate("/checkout", {});
  };

  const handleDownPayment = () => {
    setorderType("Down Payment");
    navigate("/checkout", {});
  };

  return (
    <div style={styles.container}>
      <h2>Cart Items:</h2>
      {cartItems.length > 0 ? (
        <>
          <div style={styles.cartContainer}>
            <div>
              {/* Cart List on the Left */}
              <ul style={styles.cartList}>
                {cartItems.map((item, index) => (
                  <li key={index} style={styles.cartItem}>
                    <img
                      src={item.imageUrl}
                      alt={item.title}
                      style={styles.image}
                    />
                    <div style={styles.itemDetails}>
                      <span style={{ fontWeight: "bold" }}>{item.title}</span>
                      <span> - {item.quantity} pcs</span>
                      <span style={{ fontWeight: "bold" }}>
                        {" "}
                        - Total: $
                        {(
                          parseFloat(item.price.slice(1)) * item.quantity
                        ).toFixed(2)}
                      </span>
                      <div style={styles.removeContainer}>
                        <button
                          onClick={() => handleAddItems(item)}
                          style={styles.addButton}
                        >
                          Add
                        </button>
                        <button
                          onClick={() => handleRemoveItems(item)}
                          style={styles.removeButton}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
              <button onClick={handleClearCart} style={styles.clearButton}>
                Clear Cart
              </button>
            </div>

            {/* Right Section - Totals & Payment Options */}
            <div style={styles.rightSection}>
              <div style={styles.totalContainer}>
                <h3>Total Before Tax: ${(totalAmount / 1.0825).toFixed(2)}</h3>
                <h3>Total After Tax: ${totalAmount.toFixed(2)}</h3>
              </div>
              {/* 
            <ToggleButtonGroup
              sx={{
                padding: "1rem", // Reduce padding
                display: "flex", // Align buttons in a row
                justifyContent: "center",
              }}
              value={paymentType}
              onChange={handleToggle}
              color="primary"
              exclusive
              aria-label="Payment Type"
            >
              <ToggleButton
                sx={{
                  padding: "6px 12px", // Reduce button padding
                  fontSize: "0.7rem", // Smaller text
                  // minWidth: "120px", // Limit button width
                  // height: "40px", // Reduce button height
                }}
                value="Debit/Credit" 
                aria-label="Debit/Credit"
              >Debit/Credit</ToggleButton>
              <ToggleButton
              sx={{
                padding: "6px 12px", // Reduce button padding
                fontSize: "0.7rem", // Smaller text
                // minWidth: "120px", // Limit button width
                // height: "40px", // Reduce button height
              }}
              value="Paypal, Venmo, ApplePay" 
              aria-label="Paypal, Venmo, ApplePay"
              >Paypal, Venmo, ApplePay</ToggleButton>
            </ToggleButtonGroup> */}
              {/* <p style={{fontSize:".8rem"}}>{paymentType === "Debit/Credit" ? "fee: 2.99% + $.49": "fee: 3.49% + $.49"}</p> */}
              {/* <h3>
              {paymentType === "Debit/Credit" 
                ? `Total After Fee: $${(totalAmount * 1.0299 + 0.49).toFixed(2)}` 
                : `Total After Fee: $${(totalAmount * 1.0349 + 0.49).toFixed(2)}`
              }
            </h3> */}
              {(() => {
                let total = totalAmount;
                // if (paymentType === "Debit/Credit"){
                //   total = (totalAmount * 1.0299 + .49).toFixed(2)
                // }
                // else {
                //   total = (totalAmount * 1.0349 + .49).toFixed(2)
                // }

                const matchingRule = discountRules.find(
                  (rule) =>
                    total >= rule.priceRange.min && total <= rule.priceRange.max
                );

                if (matchingRule) {
                  const discount =
                    (total * matchingRule.discountPercentage) / 100;
                  const discountedTotal = total - discount;
                  return (
                    <div style={styles.discountContainer}>
                      <h3>
                        Discount Percentage Applied:{" "}
                        {matchingRule.discountPercentage}% <br />
                        Discounted Amount: -${discount.toFixed(2)}
                        <br></br>
                      </h3>
                      <h3>
                        Total after deductions: ${discountedTotal.toFixed(2)}
                        <br />
                      </h3>
                    </div>
                  );
                } else {
                  return (
                    <div style={styles.discountContainer}>
                      <h3>No Discount Applied</h3>
                      <h3>
                        Final Total ${total}
                        <br />
                      </h3>
                    </div>
                  );
                }
              })()}
              {/* {FundsinAcct !== 0 && (
                <div style={styles.checkBoxContainer}>
                  <label style={{ fontSize: ".9rem" }}>
                    Use funds in your account? ${FundsinAcct}
                  </label>
                  <Checkbox
                    value={useFunds}
                    onChange={(e) => setuseFunds(e.target.value)}
                  ></Checkbox>
                </div>
              )} */}

              <div style={styles.checkBoxContainer}>
                <label style={{ fontSize: ".9rem" }}>Pick up at store</label>
                <Checkbox
                  value={isPickup}
                  onChange={handlePickupChange}
                ></Checkbox>
              </div>

              {(() => {
                let total = totalAmount;
                // if (paymentType === 'Debit/Credit') {
                //   total = (totalAmount * 1.0299 + 0.49).toFixed(2)
                // } else {
                //   total = (totalAmount * 1.0349 + 0.49).toFixed(2)
                // }
                return (
                  <div style={{display:"flex", flexDirection: "column", alignContent:"center", alignItems:"center"}}>
                    <button
                      onClick={handleCheckout}
                      style={
                        total === 0 ||
                        total < 500 ||
                        (month !== 5 &&
                          (month > 6 || (month === 6 && date > 4)) &&
                          month !== 10 &&
                          month !== 11)
                          ? styles.checkoutButtonDisabled
                          : styles.checkoutButton
                      }
                      disabled={
                        total === 0 ||
                        total < 500 ||
                        (month !== 5 &&
                          (month > 6 || (month === 6 && date > 4)) &&
                          month !== 10 &&
                          month !== 11)
                      }
                    >
                      Proceed to Checkout
                    </button>
                    {/* <button
                      onClick={handleDownPayment}
                      style={
                        total < 500 ||
                        (month !== 5 &&
                          (month > 6 || (month === 6 && date > 4)) &&
                          month !== 10 &&
                          month !== 11)
                          ? styles.checkoutButtonDisabled
                          : styles.checkoutButton
                      }
                      disabled={
                        total < 500 ||
                        (month !== 5 &&
                          (month > 6 || (month === 6 && date > 4)) &&
                          month !== 10 &&
                          month !== 11)
                      }
                    >
                      20% Down Payment
                    </button> */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <p
                        style={{
                          display: "inline-block", // Fit the content
                          textAlign: "center", // Center-align text
                          padding: "10px", // Add padding
                          color: "white",
                          backgroundColor: "#c53b3a",
                          borderRadius: "5px", // Optional: round corners
                        }}
                      >
                        NO REFUNDS, NO RETURNS
                      </p>
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>
        </>
      ) : (
        <p>Your cart is empty!</p>
      )}

      <div>
        <h2 style={{ textAlign: "center" }}>Discount Rules:</h2>
        {discountRules.map((rule, index) => (
          <div key={rule._id} style={{ textAlign: "center" }}>
            <p>
              <strong>Price Range:</strong> ${rule.priceRange.min}
              {rule.priceRange.max == 9999999 ? "+" : " - $" + rule.priceRange.max}
            </p>
            <p>
              <strong>Discount Percentage:</strong> {rule.discountPercentage}%
            </p>

            {index !== discountRules.length - 1 && <hr style={{ width: "80%", margin: "10px auto" }} />}

          </div>
        ))}
      </div>
    </div>
  );
}

export default CartPage;

// Styles
const styles = {
  cartContainer: {
    display: "flex", // ✅ Enables horizontal layout
    justifyContent: "space-between", // ✅ Distributes content to left and right
    alignItems: "flex-start", // ✅ Aligns items at the top
    gap: "20px", // ✅ Adds spacing between left and right sections
    // padding: "1rem",
    width: "100%",
    flexDirection: window.innerWidth < 768 ? "column" : "row", // ✅ Changes only on mobile
    // flexDirection: "column", // ✅ Stack elements on mobile
  },
  cartList: {
    flex: "1", // ✅ Takes up available space on the left
    listStyle: "none",
    padding: "0",
    margin: "0",
    listStyleType: "none",
    maxWidth: "500px", // ✅ Prevents full width on large screens
  },
  cartItem: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    borderBottom: "1px solid #ddd",
    padding: "10px",
    justifyContent: "space-between",
    marginBottom: "1rem",
    // borderBottom: "1px solid #ccc",
    paddingBottom: "0.5rem",
    flexDirection: "column", // ✅ Stack image & text on mobile
  },
  image: {
    width: "100px",
    height: "100px",
    objectFit: "cover",
    borderRadius: "5px",
    marginRight: "1rem",
  },
  itemDetails: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  rightSection: {
    display: "flex",
    flexDirection: "column", // ✅ Stack elements on top of each other
    alignItems: "center", // ✅ Align to the left
    // gap: "10px", // ✅ Adds spacing between elements
    flex: "0.6", // ✅ Takes up less space than the cart list
    border: "1px solid #ddd",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#f5f5f5",
  },
  totalContainer: {
    backgroundColor: "#f5f5f5",
    // padding: "1rem",
    // borderRadius: "5px",
    textAlign: "center",
    marginTop: "1rem",
    fontWeight: "bold",
  },
  discountContainer: {
    backgroundColor: "#f5f5f5",
    padding: "1rem",
    // borderRadius: "5px",
    textAlign: "center",
    // marginTop: "1rem",
    fontWeight: "bold",
  },
  checkBoxContainer: {
    backgroundColor: "#f5f5f5",
    textAlign: "center", // ✅ Centers text inside label
    display: "flex", // ✅ Enables Flexbox
    alignItems: "center", // ✅ Aligns items vertically
    justifyContent: "center", // ✅ Centers content horizontally
    gap: "8px", // ✅ Adds spacing between label and checkbox
    padding: "10px", // ✅ Adds some padding for better appearance
    borderRadius: "5px", // ✅ Optional: Rounds the container edges
  },

  CenterStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  deleteButton: {
    marginLeft: "10px",
    backgroundColor: "red",
    color: "white",
    border: "none",
    borderRadius: "5px",
    padding: "5px 10px",
    cursor: "pointer",
  },
  adminSection: {
    padding: "20px",
    border: "1px solid #ccc",
    marginTop: "20px",
  },
  container: {
    padding: "1rem",
    maxWidth: "800px",
    margin: "0 auto",
    textAlign: "left",
    marginTop: "70px",
  },
  removeContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: "0.5rem",
  },
  input: {
    width: "50px",
    padding: "0.2rem",
    marginRight: "0.5rem",
  },
  addButton: {
    // backgroundColor: "#28a745",
    color: "black",
    border: "none",
    padding: "0.25rem .5rem",
    cursor: "pointer",
    // borderRadius: "4px",
    marginRight: "1rem",
  },
  removeButton: {
    // backgroundColor: "#ff4d4f",
    color: "black",
    border: "none",
    padding: "0.25rem .5rem",
    cursor: "pointer",
    // borderRadius: "4px",
  },
  clearButton: {
    backgroundColor: "#c53b3a",
    color: "white",
    border: "none",
    padding: "0.5rem 1rem",
    cursor: "pointer",
    borderRadius: "4px",
    marginTop: "1rem",
  },
  checkoutButton: {
    backgroundColor: "#51a4ac",
    color: "white",
    border: "none",
    padding: "0.5rem",
    cursor: "pointer",
    borderRadius: "4px",
    // marginTop: "1rem",
    marginLeft: ".1rem",
    fontSize: "1rem",
  },
  checkoutButtonDisabled: {
    backgroundColor: "grey",
    color: "white",
    border: "none",
    padding: "0.5rem 1rem",
    // cursor: "pointer",
    borderRadius: "4px",
    // marginTop: "1rem",
    marginLeft: ".1rem",
    fontSize: "1rem",
  },
};
